import * as api from "../constants/api";
import axios from "../services/axios";
import { compareAsc, parseDate } from "../utils/date";
import { setTotal as setTotalAction } from "./advancedListActions";

import { addFlashMessage } from "./FlashMessagesAction";

import { getErrorMessageFromAxiosError } from "../utils/axiosUtils";
import { toIsoString } from "../utils/date";

export const GET_MILJOGEBYR_TIL_BEHANDLING_SUCCESS =
  "GET_MILJOGEBYR_TIL_BEHANDLING_SUCCESS";

export function getMiljogebyrTilBehandling(params, page, count) {
  const statusFilter = {
    // Skal stå på gamla måtet tils det er endret på backend
    isVenter: null,
    isMaKvalitetsikres: true,
    isTilEttersendelse: true,
    isEttersendt: null,
    isMakulert: false,
    isKlarTilKemner: null,
    isStoppetAvSystemet: true,
    isFeiletKemner: null,
    isSendtKemner: null,
    isBetalt: null,
  };

  return async (dispatch) => {
    return axios
      .get(api.GET_MILJOGEBYRER_URL, {
        params: {
          ...params,
          fraDato: params.fraDato && toIsoString(params.fraDato),
          tilDato: params.tilDato && toIsoString(params.tilDato),
          origin: "til_behandling",
          ...statusFilter,
          page: page,
          pageSize: count,
        },
      })
      .then(async (response) => {
        let result = response && response.data && response.data.result;

        if (!result) {
          return Promise.reject(false);
        }

        var total = JSON.parse(response.headers["x-pagination"]).Total;
        dispatch(setTotalAction("miljogebyrTilBehandling", total));

        result = result.sort((r1, r2) => {
          const cmp = compareAsc(
            parseDate(r1.ileggelsesdatoTil),
            parseDate(r2.ileggelsesdatoTil)
          );
          return Number.isNaN(cmp) ? 0 : cmp;
        });

        dispatch({
          type: GET_MILJOGEBYR_TIL_BEHANDLING_SUCCESS,
          payload: result,
        });
      })
      .catch(catchFunction);
  };
}

const catchFunction = (error) => {
  return (dispatch) => {
    const errorMessage = getErrorMessageFromAxiosError(error);
    dispatch(
      addFlashMessage({
        type: "error",
        text: errorMessage,
      })
    );
    return Promise.reject(error);
  };
};
